import React, { useContext, useEffect, useState } from 'react'
import 'src/views/container/cms/content.scss'
import '../../../scss/style.scss'
import { convertDuration, getThumbnail, isEmpty } from '../../../views/utils/helper'
import moment from 'moment'
import useAxios from 'axios-hooks'
import { AppContext } from 'src/views/context/app'
import { CONTENT_FILTER_XAVIER } from '../../../views/utils/urls'
import Loading from 'react-fullscreen-loading'
import AssetFilter from '../../../views/container/AssetManager/AssetFilter'
import InfiniteScroll from 'react-infinite-scroll-component'
import { GlobalContext } from 'src/views/context/GlobalState'
import CustomCard from '../../../views/container/AssetManager/customCard'
import GridViewIcon from '../../../assets/Content-Icons/Svgs/grid-view-icon.svg'
import ListViewIcon from '../../../assets/Content-Icons/Svgs/list-view-icon.svg'
import CustomListCard from '../../../views/container/AssetManager/customListCard'
import { PAGE_SIZE } from 'src/views/utils/constants'
import { isArray } from 'lodash'

const DefaultSwimlaneManual = ({
  setPreviewContent,
  selectedContents,
  setSelectedContents,
  setSwimlanePreviewContents,
  categoryMasterData = [],
  subCategoryMasterData = [],
  subscriptionMasterData = [],
  ppvMasterData = [],
  artistData = [],
}) => {
  const { userSessionObj } = useContext(GlobalContext)

  const [page, setPage] = useState(1)
  const [categoryFilter, setCategoryFilter] = useState([])
  const [subCategoryFilter, setSubCategoryFilter] = useState([])
  const [subscriptionFilter, setSubcriptionFilter] = useState([])
  const [PPVFilter, setPPVFilter] = useState([])
  const [artistFilter, setArtistFilter] = useState([])
  const [searchText, setSearchText] = useState('')
  const { setLoader, loader } = useContext(AppContext)
  const [listView, setListView] = useState(false) // state to set the grid view and list view

  const [contentData, setContentData] = useState([])

  const [filters, setFilters] = useState([])
  const [filterPayloadObj, setFilterPayloadObj] = useState({
    video_types: ['SPV', 'MPVP', 'MPVC', 'LIVE', 'VOD_LIVE', 'PLAYLIST'],
  })
  // change field filters

  useEffect(() => {
    if (!isEmpty(selectedContents) && !isEmpty(contentData)) {
      let tempPreviewArr = []
      for (let i = 0; i < selectedContents.length; i++) {
        const contentID = selectedContents[i]

        let contenObj = contentData.find((ele) => ele.content_id === contentID)
        if (contenObj) {
          tempPreviewArr.push(contenObj)
        }
      }
      setSwimlanePreviewContents([...tempPreviewArr])
    }
  }, [selectedContents, contentData])
  useEffect(() => {
    setFilterPayloadObj({
      system_defined: [
        {
          key: 'category',
          name: 'Category',
          filter_type: 'AND',
          operator: 'eq',
          values: categoryFilter,
        },
        {
          key: 'sub_categories',
          name: 'Sub-Category',
          filter_type: 'AND',
          operator: 'eq',
          values: subCategoryFilter,
        },
        {
          key: 'active_subscription',
          name: 'Subscription',
          filter_type: 'AND',
          operator: 'eq',
          values: subscriptionFilter,
        },
        {
          key: 'active_ppv',
          name: 'PPV',
          filter_type: 'AND',
          operator: 'eq',
          values: PPVFilter,
        },
        {
          key: 'artists',
          name: 'Artist',
          filter_type: 'AND',
          operator: 'eq',
          values: artistFilter,
        },
      ],
      search_text: searchText,
      video_types: ['SPV', 'MPVP', 'MPVC', 'LIVE', 'VOD_LIVE', 'PLAYLIST'],
    })
  }, [searchText, artistFilter, PPVFilter, subscriptionFilter, subCategoryFilter, categoryFilter])

  const filterIntialValue = [
    {
      title: 'Category',
      type: 'checkbox',
      checkedState: '',
      options: categoryMasterData.map((info) => {
        return { name: info.name, value: info._id }
      }),
      onSelect: (checked, value) => {
        //  index, setStateFunc, checked, value
        onFilterChange(0, setCategoryFilter, checked, value)
      },
    },
    {
      title: 'Sub Category',
      type: 'checkbox',
      checkedState: '',
      options: subCategoryMasterData.map((info) => {
        return { name: info.name, value: info._id }
      }),
      onSelect: (checked, value) => {
        onFilterChange(1, setSubCategoryFilter, checked, value)
      },
    },
    {
      title: 'Subscription',
      type: 'checkbox',
      checkedState: '',
      options: subscriptionMasterData.map((info) => {
        return { name: info.name, value: info._id }
      }),
      onSelect: (checked, value) => {
        onFilterChange(2, setSubcriptionFilter, checked, value)
      },
    },
    {
      title: 'PPV',
      type: 'checkbox',
      checkedState: '',
      options: ppvMasterData.map((info) => {
        return { name: info.name, value: info._id }
      }),
      onSelect: (checked, value) => {
        onFilterChange(3, setPPVFilter, checked, value)
      },
    },
    {
      title: 'Artists',
      type: 'checkbox',
      checkedState: '',
      options: artistData.map((info) => {
        return { name: info.name, value: info._id }
      }),
      onSelect: (checked, value) => {
        onFilterChange(4, setArtistFilter, checked, value)
      },
    },
  ]

  useEffect(() => {
    if (filters.filter((info) => info.checkedState !== '').length === 0) {
      setFilters([
        {
          title: 'Category',
          type: 'checkbox',
          checkedState: '',
          options: categoryMasterData.map((info) => {
            return { name: info.name, value: info._id }
          }),
          onSelect: (checked, value) => {
            //  index, setStateFunc, checked, value
            onFilterChange(0, setCategoryFilter, checked, value)
          },
        },
        {
          title: 'Sub Category',
          type: 'checkbox',
          checkedState: '',
          options: subCategoryMasterData.map((info) => {
            return { name: info.name, value: info._id }
          }),
          onSelect: (checked, value) => {
            onFilterChange(1, setSubCategoryFilter, checked, value)
          },
        },
        {
          title: 'Subscription',
          type: 'checkbox',
          checkedState: '',
          options: subscriptionMasterData.map((info) => {
            return { name: info.name, value: info._id }
          }),
          onSelect: (checked, value) => {
            onFilterChange(2, setSubcriptionFilter, checked, value)
          },
        },
        {
          title: 'PPV',
          type: 'checkbox',
          checkedState: '',
          options: ppvMasterData.map((info) => {
            return { name: info.name, value: info._id }
          }),
          onSelect: (checked, value) => {
            onFilterChange(3, setPPVFilter, checked, value)
          },
        },
        {
          title: 'Artists',
          type: 'checkbox',
          checkedState: '',
          options: artistData.map((info) => {
            return { name: info.name, value: info._id }
          }),
          onSelect: (checked, value) => {
            onFilterChange(4, setArtistFilter, checked, value)
          },
        },
      ])
    }
  }, [categoryMasterData, subCategoryMasterData, subscriptionMasterData, ppvMasterData, artistData])

  const [{ data: contentList, loading: contentListLoading }, contentListCall] = useAxios(
    {
      url: CONTENT_FILTER_XAVIER,
      method: 'post',
    },
    { manual: true },
  )

  useEffect(() => {
    contentListCall({
      data: {
        filters: filterPayloadObj,
        page: page,
        order_by: 'modified_date',
        page_size: PAGE_SIZE,
      },
    })
  }, [])

  useEffect(() => {
    setLoader(contentListLoading)
  }, [contentListLoading])

  useEffect(() => {
    if (contentList && contentList.success) {
      page === 1
        ? setContentData(contentList.data)
        : setContentData((contentData) => [...contentData, ...contentList.data])
    }
  }, [contentList])

  const onFilterChange = (index, setStateFunc, checked, value) => {
    if (checked) {
      setStateFunc((prev) => {
        handleFilterChange(index, [...prev, value])
        return [...prev, value]
      })
    } else {
      setStateFunc((prev) => {
        handleFilterChange(
          index,
          [...prev].filter((type) => type !== value),
        )
        return [...prev].filter((type) => type !== value)
      })
    }
  }

  const handleFilterChange = (index, value) => {
    setFilters((prev) => {
      prev[index] = { ...prev[index], checkedState: value }
      return [...prev]
    })
  }
  // for preview
  const handleContentSelect = (content) => {
    let tempSelectedContentsIDs = selectedContents.map((item) => item)
    if (tempSelectedContentsIDs.includes(content.content_id)) {
      setSelectedContents((prev) => prev.filter((item) => item !== content.content_id))
      return
    }
    setSelectedContents((prev) => [...prev, content.content_id])
  }

  const handleNextPage = () => {
    contentListCall({
      data: {
        filters: filterPayloadObj,
        page: page + 1,
        order_by: 'modified_date',
        page_size: PAGE_SIZE,
      },
    })
    setPage((page) => page + 1)
  }

  const handleSearch = (value) => {
    setSearchText(value)

    setPage(1)
    contentListCall({
      data: {
        filters: { ...filterPayloadObj, search_text: value },
        page: 1,
        order_by: 'modified_date',
        page_size: PAGE_SIZE,
      },
    })
  }

  const applyFilter = () => {
    setPage(1)
    contentListCall({
      data: {
        filters: filterPayloadObj,
        page: 1,
        order_by: 'modified_date',
        page_size: PAGE_SIZE,
      },
    })
  }

  const resetFilters = () => {
    setFilters(filterIntialValue)
    setCategoryFilter([])
    setSubCategoryFilter([])
    setSubcriptionFilter([])
    setPPVFilter([])
    setArtistFilter([])
    setPage(1)
    contentListCall({
      data: {
        filters: {
          search_text: searchText,
          video_types: ['SPV', 'MPVP', 'MPVC', 'LIVE', 'VOD_LIVE', 'PLAYLIST'],
        },
        page: 1,
        order_by: 'modified_date',
        page_size: PAGE_SIZE,
      },
    })
  }
  return (
    <div>
      <div
        className="d-flex justify-content-center mt-2"
        style={{
          padding: '1.42vw 0vw 0',
          margin: '0 auto 3vh',
          width: '100%',
          visibility: 'unset',
          position: 'relative',
        }}
      >
        <div
          style={{ marginRight: 'auto', fontSize: '14px' }}
          className="d-flex align-items-center"
        >
          <h6>{selectedContents.length} Contents Selected</h6>
        </div>
        <AssetFilter
          filters={filters}
          onSearch={handleSearch}
          onApply={applyFilter}
          onClearAll={resetFilters}
          dropdownHeight={'300px'}
        />
        <div
          className="d-flex justify-content-start align-items-center rounded-1 overflow-hidden"
          style={{ border: '0.5px solid #707070' }}
        >
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              height: '100%',
              backgroundColor: !listView ? '#000' : '#fff',
              padding: 'max(.42vw,8px) .84vw',
              cursor: 'pointer',
            }}
            onClick={() => setListView(false)}
          >
            <img
              src={GridViewIcon}
              alt=""
              className="h-100"
              style={{ filter: !listView ? 'invert(0)' : 'invert(1)' }}
            />
          </div>
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              height: '100%',
              backgroundColor: listView ? '#000' : '#fff',
              padding: 'max(.42vw,8px) .84vw',
              cursor: 'pointer',
            }}
            onClick={() => setListView(true)}
          >
            <img
              src={ListViewIcon}
              alt=""
              className="h-100"
              style={{ filter: !listView ? 'invert(0)' : 'invert(1)' }}
            />
          </div>
        </div>
      </div>
      <div id="scrollableDiv" className="asset-manager-card position-relative">
        <Loading loading={loader} background={'rgba(60, 60, 60, 0.6)'} loaderColor="#efefef" />
        <InfiniteScroll
          dataLength={contentData.length} //This is important field to render the next data
          next={handleNextPage}
          hasMore={contentList && contentList.total > page * 20}
          style={{ overflowX: 'hidden' }}
          loader={<p>Loading...</p>}
          className="scrollbar-class"
          height={`45vh`}
          scrollableTarget="scrollableDiv"
        >
          {listView && (
            <div
              className="d-flex justify-content-center align-items-center w-100 bg-black text-white position-absolute"
              style={{
                fontSize: 'max(0.63vw,10px)',
                gap: '0 2.2%',
                padding: '2px .6vw',
                top: '0',
                zIndex: '10',
              }}
            >
              <div style={{ width: '9%', height: '100%' }}></div>
              <div
                className="d-flex justify-content-between align-items-center"
                style={{ width: '85%' }}
              >
                <p style={{ marginBlockEnd: '0', width: '20%' }}>Title</p>
                <p style={{ marginBlockEnd: '0', width: '10%' }}>Duration</p>
                <p style={{ marginBlockEnd: '0', width: '10%' }}>Released Date</p>
                <p style={{ marginBlockEnd: '0', width: '10%' }}>Content Type</p>
                <p style={{ marginBlockEnd: '0', width: '15%' }}>Category</p>
                <div style={{ width: '2%' }}></div>
              </div>
            </div>
          )}
          <div
            className="d-flex flex-wrap"
            style={{
              gap: listView ? '1.2vw 0' : '1.2vw 1.6%',
              padding: listView ? '30px 8px 20px 8px' : '20px 8px 20px 8px',
            }}
          >
            {!isEmpty(contentData) ? (
              contentData.map((info, index) =>
                listView ? (
                  <CustomListCard
                    cardImage={getThumbnail(
                      userSessionObj.session_data.cf_domain_name,
                      info?.thumbnail,
                    )}
                    fileName={info?.title}
                    releasedDate={moment(info?.publish_time).format('DD MMM YYYY')}
                    duration={
                      info?.source_asset || info?.live_expiry_time
                        ? info?.source_asset?.file_metadata?.duration
                          ? convertDuration(info?.source_asset?.file_metadata?.duration)
                          : moment(info?.live_expiry_time).diff(
                              moment(info?.publish_time),
                              'hours',
                            ) +
                            'h ' +
                            (moment(info?.live_expiry_time).diff(
                              moment(info?.publish_time),
                              'minutes',
                            ) %
                              60) +
                            'm'
                        : 'N/A'
                    }
                    key={index}
                    contentType={info?.video_type}
                    categories={
                      isArray(info?.category)
                        ? info?.category.map((info) => info.name)
                        : [info?.category.name]
                    } // categories
                    actionButton={'PREVIEW'}
                    actionButtonAction={() => setPreviewContent(info)}
                    isSelectable={true}
                    onSelect={() => handleContentSelect(info)}
                    isMultipleSelectable={true}
                    isSelected={selectedContents.map((item) => item).includes(info?.content_id)}
                  />
                ) : (
                  <CustomCard
                    cardImage={getThumbnail(
                      userSessionObj.session_data.cf_domain_name,
                      info?.thumbnail,
                    )}
                    playIconForVideo={true}
                    fileName={info?.title}
                    leftText={info?.video_type}
                    rightText={moment(info?.publish_time).format('DD MMM YYYY')}
                    // if it's a live stream duration will be the streaming duration(differece of live_expiry_time and publish_time)
                    key={index}
                    isSelectable={true}
                    onSelect={() => handleContentSelect(info)}
                    isMultipleSelectable={true}
                    isSelected={selectedContents.map((item) => item).includes(info?.content_id)}
                    // selectedContents={selectedContents}
                    actionButton={'PREVIEW'}
                    actionButtonAction={() => setPreviewContent(info)}
                  />
                ),
              )
            ) : (
              <h5 className="no-data-text">No Content Found!</h5>
            )}
          </div>
        </InfiniteScroll>
      </div>
      <p
        style={{
          fontSize: 'max(0.73vw,10px)',
          color: '#000',
          marginBlockEnd: '0',
          margin: '20px 0 -29px',
        }}
      >
        * Click individual thumbnails to Add
      </p>
    </div>
  )
}

export default DefaultSwimlaneManual
